
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_47765","data-name":"Group 47765","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15797","data-name":"Rectangle 15797","width":"18","height":"18","fill":"none"}}),_c('g',{attrs:{"id":"Group_47764","data-name":"Group 47764"}},[_c('g',{attrs:{"id":"Group_47768","data-name":"Group 47768"}},[_c('path',{attrs:{"id":"Path_33962","data-name":"Path 33962","d":"M15.9 8.463a2.278 2.278 0 00-1.044-1.424L5.243 1.456A2.125 2.125 0 004.1 1.193a2.164 2.164 0 00-2.057 2.244v11.107A2.168 2.168 0 004.2 16.81a2.184 2.184 0 001.053-.275l9.606-5.581a2.3 2.3 0 00.76-.76 2.277 2.277 0 00.281-1.731m-1.3 1.1a1.08 1.08 0 01-.35.355L4.666 15.49a.963.963 0 01-1.306-.381.989.989 0 01-.117-.537V3.4a.963.963 0 01.916-1.006H4.2a.956.956 0 01.451.111l9.583 5.568a1.09 1.09 0 01.361 1.5","fill":"#727998"}})])])])
          )
        }
      }
    